module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-29@2x-217bdc38b3d68a509617ba4b5d65e1ea.png";